var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopybot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4482_39501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6631 18.3016C12.6631 19.029 12.1185 19.7563 11.2109 19.7563C10.4849 19.7563 9.75879 19.2108 9.75879 18.3016C9.75879 17.5743 10.3033 16.8469 11.2109 16.8469C11.937 16.8469 12.6631 17.5743 12.6631 18.3016Z",
    fill: "#A6B3C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9004 18.3016C18.9004 19.029 18.3558 19.7563 17.4482 19.7563C16.7222 19.7563 15.9961 19.2108 15.9961 18.3016C15.9961 17.5743 16.5407 16.8469 17.4482 16.8469C18.1743 16.8469 18.9004 17.5743 18.9004 18.3016Z",
    fill: "#A6B3C9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9945 22.677H8.79577C7.27501 22.677 6.0415 21.5728 6.0415 20.2114V19.4929C6.0415 15.4013 9.75047 12.0811 14.3212 12.0811H14.4691C19.0398 12.0811 22.7488 15.4013 22.7488 19.4929V20.2114C22.7488 21.5728 21.5153 22.677 19.9945 22.677Z",
    stroke: "#A6B3C9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3973 9.83525C15.5198 9.83525 16.4299 8.92524 16.4299 7.80269C16.4299 6.68015 15.5198 5.77014 14.3973 5.77014C13.2748 5.77014 12.3647 6.68015 12.3647 7.80269C12.3647 8.92524 13.2748 9.83525 14.3973 9.83525Z",
    stroke: "#A6B3C9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47591 5.29789C9.59846 5.29789 10.5085 4.38789 10.5085 3.26534C10.5085 2.14279 9.59846 1.23279 8.47591 1.23279C7.35337 1.23279 6.44336 2.14279 6.44336 3.26534C6.44336 4.38789 7.35337 5.29789 8.47591 5.29789Z",
    stroke: "#A6B3C9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3975 9.21588V11.8777",
    stroke: "#A6B3C9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8605 8.44463C11.7738 8.05505 11.4327 7.34824 8.67898 7.34827C5.23683 7.34829 1.40527 10.5655 1.40527 14.6571V15.3756C1.40527 16.737 2.63878 17.8412 4.15954 17.8412C4.77919 17.8412 5.36027 17.8412 5.91371 17.8412",
    stroke: "#A6B3C9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47607 4.38019V7.04204",
    stroke: "#A6B3C9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4482_39501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopybot);
export default __webpack_public_path__ + "static/media/copy bot.d9ea7754a4109ae59c16825976386c10.svg";
export { ForwardRef as ReactComponent };